import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  headerBtn: {
    padding: "2px",
    margin: "0 15px",
    [theme.breakpoints.down("xs")]: {
      margin: "0 8px",
      "& svg": {
        color: "#777",
      },
    },
  },
  closeIcon: {
    color: '#CCCCCC'
  },
  imageWidht: {
    width: "100%",
  },
  popoverList: {
    cursor: "pointer",
    maxWidth: 360,
    padding: "0",
  },
  gifPopover: {
    "& .MuiPopover-paper": {
      paddingBottom: '0 !important',
      height: 'auto !important',
      width: 'auto !important',
    },
    "& .reactGiphySearchbox-poweredByGiphy": {
      display: 'none'
    }
  },
  selectedFavIcon: {
    "& svg": {
      color: "#E1426E",
    },
  },
  selectedLikeIcon: {
    "& svg": {
      color: "#F3994E",
    },
  },
  notifTitle: {
    boxShadow: '0px 1px 3px #00000029',
    padding: "5px 16px",
    "& h6": {
      padding: "6px 0",
    },
  },
  readMessage: {
    background: '#F8F8F8',
    "& h6, p": {
      color: "#5E6066",
    },
  },
  vertDivider: {
    margin: "0 4px",
    lineHeight: "8px",
  },
  uploadBtn: {
    width: 20,
    marginTop: "-20px",
    height: 20,
    "&:hover": {
      background: "none",
    },
    "& .MuiIconButton-root": {
      marginTop: "0 !important",
    },
    "& .MuiInputLabel-root": {
      borderBottom: "none",
    },
  },
  btnBorder: {
    border: "solid 1.5px",
    borderColor: theme.palette.primary.main,
    borderRadius: 4,
    height: 18,
    width: 18,
    padding: 9,
  },
  msgReaction: {
    "& button": {
      background: theme.palette.secondary.main,
      width: 24,
      height: 24,
      margin: 5,
      "&:hover": {
        background: theme.palette.secondary.main,
      },
    },
    "& svg": {
      color: "#fff",
      fontSize: 16,
    },
  },
  rotate: {
    transform: "rotate(-45deg)",
    marginTop: "-2px",
  },
  replyButton: {
    padding: "0 6px",
    borderRadius: 0,
    marginLeft: 16,
    borderLeft: "solid 1px #DEDADA",
  },
  likes: {
    position: "absolute",
    top: 8,
    right: 10,
    "& button": {
      border: "solid 1px",
      borderColor: theme.palette.primary.main,
      borderRadius: "50%",
      width: 22,
      height: 22,
      padding: "unset",
      cursor: "default",
    },
    "& svg": {
      fontSize: 14,
    },
  },
  notifAction: {
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: -28,
    "& svg": {
      width: 22,
    },
    "& button": {
      marginRight: 5,
    },
  },
  replyTextfield: {
    marginBottom: "0 !important",
    "& button": {
      padding: 5,
      marginRight: 0,
      width: 32,
      height: 32,
      "& svg": {
        fontSize: 18,
      },
    },
    "& textarea": {
      border: "solid 1px #EDEDED !important",
      background: '#fff !important',
    },
    "& .mention-input": {
      minWidth: '86%',
      maxWidth: '86%'
    }
  },
  clearBtn: props => {
    const txtColor =
      props.appTheme === "CLASSIC"
        ? theme.palette.primary.main
        : props.appTheme === "LIGHT"
          ? "#777"
          : theme.palette.primary.main;
    return {
      color: txtColor,
    };
  },
  vertDivider: {
    color: '#DADADA',
    margin: '0 3px'
  },
  emojiPicker: {
    "& svg": {
      transform: "rotate(0deg)",
      borderRadius: 50,
    },
  },
  notifList: {
    "& li": {
      padding: "8px 16",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
  },
  mobileMenuName: {
    margin: "0 0 0 10px",
    paddingLeft: "5px",
    fontSize: 14,
  },
  notifPopover: {
    "& .MuiPopover-paper": {
      // maxHeight: "60vh",
      // height: "100%",
      overflow: "hidden",
      width: 360,
    },
  },
  disableBtn: {
    color: '#CAC3C3 !important',
    pointerEvents: 'none'
  }
}));
